export interface IFormValues {
  platflomName: string;
  DBAName: string;
  dateofbirth: string;
  companyRegisteredName: string;
  companyAddress: string;
  companyRegisteredNumber: string;
  ownerName: string;
  pic: string;
  UEN: string;
  TotalPayment: string;
  IndividualAName: string;
  IndividualANum: string;
  IndividualBName: string;
  IndividualBNum: string;
  IndividualCName: string;
  IndividualCNum: string;
  detailName: string;
  detailAddress: string;
  detailNationality: string;
  detailDate: string;
  address: string;
  addressInfo: {
    state: string;
    city: string;
    district: string;
    address: string;
  };
  companyTradingName: string;
  website: string;
  contactPerson: string;
  phoneAreaCode: string;
  phoneNumber: string;
  email: string;
  bankName: string;
  bankAccountOwner: string;
  // accountNumber: string;
  accountNumber: string;
  // bankName: string;
  swiftCode: string;
  bankCode: string;
  branchCode: string;
  currency: string;
  bank: {
    bankName: string;
    bankAccountOwner: string;
    accountNumber: string;
    swiftCode: string;
    bankCode: string;
    branchCode: string;
    currency: string;
  };
  fileInfo: IFileDetails[];
  agreement1: boolean;
  agreement2: boolean;
  agreement3: boolean;
  senior_name1: string;
  senior_name2: string;
  senior_name3: string;
  senior_position1: string;
  senior_position2: string;
  senior_position3: string;
  senior_num1: string;
  senior_num2: string;
  senior_num3: string;
}

export interface IFileDetails {
  fileFullPath: string;
  filePath: string;
  fileName: string;
}

export enum ComponentEnum {
  INPUT = 'INPUT',
  DROP_LIST = 'DROP_LIST',
  ADDRESS_CASCADE = 'ADDRESS_CASCADE',
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  TIME = 'TIME',
  DATE_TIME = 'DATE_TIME',
  FILE = 'FILE',
  PASSWORD = 'PASSWORD',
  EMAIL = 'EMAIL',
  URL = 'URL',
  TEXT_AREA = 'TEXT_AREA',
  RADIO = 'RADIO',
  CHECKBOX = 'CHECKBOX',
  MOBILE_GLOBAL = 'MOBILE_GLOBAL',
}

export interface ISteps {
  stepEnName: string;
  stepFieldConfigs: any[];
  stepLocalName: string;
}

export interface IBottom {
  elementEnScript: string;
  elementLocalScript: string;
}
